import moment from "moment";
import React from "react";

import { useSettings } from "./context/settings";

const AppFooter = (props: any) => {
    const settings = useSettings();

    return (
        <div className="layout-footer">
            <div className="footer-logo-container"></div>

            {settings.MISSION_NAME ? (
                <span className="copyright">
                    &#169; {settings.MISSION_NAME}: {moment(settings.MISSION_START_DATE).utc().format("DD/MM/YYYY")} à{" "}
                    {moment(settings.MISSION_END_DATE).utc().format("DD/MM/YYYY")}
                </span>
            ) : (
                <span className="copyright">&#169; Missões Espontâneas 2022 - {new Date().getFullYear()}</span>
            )}
        </div>
    );
};

export default AppFooter;
